import React from 'react'

import { Box, Typography } from '../'

import { Color } from '@/utils'

const HelperText = ({ text, isError, isDisabled = false }) => (
    <Box margin="5px 0 0">
        <Typography
            color={
                isError ? Color.red : isDisabled ? Color.textDisabled : Color.gray700
            }
            variant="caption1"
        >
            {text}
        </Typography>
    </Box>
)

export { HelperText }
